import React, { useState, useEffect } from "react";

import { request, reportErrorToHoneybadger } from '../../helpers/Requests'

const ServiceForm = ({ setService, setBookingFormDisabled, setPage, organisation_id, location_id }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [services, setServices] = useState([]);
  const [categorisedServices, setCategorisedServices] = useState([]);
  const [uncategorisedServices, setUncategorisedServices] = useState(null);
  const [expandedCategoryIds, setExpandedCategoryIds] = useState([]);

  useEffect(() => {
    request('GET', `/v1/b/services?booking[organisation_id]=${organisation_id}&booking[location_id]=${location_id}`)
      .then(data => {
        const servicesWithCategory = data.filter(item => item.category_id !== null);
        const servicesWithoutCategory = data.filter(item => item.category_id === null)[0];
        const flatServices = data.flatMap(category => category.services);

        setCategorisedServices(servicesWithCategory)
        setUncategorisedServices(servicesWithoutCategory)
        setServices(flatServices)

        if (servicesWithCategory.length > 0) {
          if (!servicesWithoutCategory || servicesWithoutCategory.services.length < 10) {
            setExpandedCategoryIds([servicesWithCategory[0].category_id]);
          }
        }
        setLoaded(true)
      })
      .catch(data => {
        reportErrorToHoneybadger(data.errors)

        setError(data.errors.join(", "))
        setBookingFormDisabled(true)
      })
  }, [organisation_id, location_id, setBookingFormDisabled]);

  const toggleCategory = (categoryId) => {
    setExpandedCategoryIds(prevIds => prevIds.includes(categoryId) ? prevIds.filter(id => id !== categoryId) : [...prevIds, categoryId]);
  };

  const handleService = (event) => {
    const id = parseInt(event.target.id)
    const service = services.find(service => service.id === id);

    setService(service)
    setPage("staff")
  }

  if (error) {
    return (
      <div className="booking-container">
        <div className="error">{error}</div>
      </div>
    )
  }

  if (loaded === false) {
    return (
      <div className="service-selection">
        <p>Loading ...</p>
      </div>
    )
  }

  const renderUncategorised = () => {
    if (uncategorisedServices) {
      return (
        <div className="service-form">
          {uncategorisedServices.services.map(service => (
            <div className="selection" key={service.id} id={service.id} onClick={handleService}>
              {service.name} - {service.default_price}
            </div>
          ))}
        </div>
      )
    }
  }

  const renderCategorised = () => {
    return (
        <div className="bottom-margin padding-bottom">
          {categorisedServices.map(service_category => {
            const categoryId = service_category.category_id
            const isExpanded = expandedCategoryIds.includes(categoryId);
            return (
              <div key={categoryId}>
                <div className={"category-header"} onClick={() => toggleCategory(categoryId)}>
                  {service_category.category_name} {isExpanded ? '▲' : '▼'}
                </div>
                {isExpanded && (
                  <div className="service-form no-top-border-radius no-top-border">
                      {service_category.services.map(service => (
                        <div className="selection no-top-border-radius" key={service.id} id={service.id} onClick={handleService}>
                          {service.name} - {service.default_price}
                        </div>
                      ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
    )
  }

  if (loaded === true) {
    return (
      <>
        <h3>Service Selection</h3>
        {renderUncategorised()}
        {renderCategorised()}
      </>
    )
  }
}

export default ServiceForm;
